import React, { useState, useEffect } from 'react';
import { Button, Popconfirm, message, Empty } from 'antd';
import { DeleteOutlined, FolderOpenOutlined } from '@ant-design/icons';

const STORAGE_KEY = 'choicedekho_image_studio_templates';

export default function TemplateGallery({ onLoadTemplate }) {
  const [templates, setTemplates] = useState([]);

  // Load templates from localStorage
  const loadTemplatesFromStorage = () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        setTemplates(JSON.parse(stored));
      } else {
        setTemplates([]);
      }
    } catch (e) {
      console.error('Failed to parse templates from localStorage', e);
      setTemplates([]);
    }
  };

  useEffect(() => {
    loadTemplatesFromStorage();
  }, []);

  const handleDelete = (id, e) => {
    e.stopPropagation();
    const updated = templates.filter((t) => t.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    setTemplates(updated);
    message.success('Template deleted.');
  };

  if (templates.length === 0) {
    return (
      <div style={{ padding: '40px 0' }}>
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <span style={{ color: '#bfbfbf', fontSize: '13px' }}>
              No saved templates found. Design something and click "Save for Later"!
            </span>
          }
        />
      </div>
    );
  }

  return (
    <div className="template-gallery-grid">
      {templates.map((tpl) => (
        <div key={tpl.id} className="template-card">
          <div className="template-card-preview" onClick={() => onLoadTemplate(tpl.canvasJSON)}>
            {tpl.thumbnailUrl ? (
              <img src={tpl.thumbnailUrl} alt={tpl.name} />
            ) : (
              <FolderOpenOutlined style={{ fontSize: '36px', color: '#ccc' }} />
            )}
          </div>
          <div className="template-card-info">
            <div className="template-card-title" title={tpl.name}>
              {tpl.name}
            </div>
            <div className="template-card-date">
              {new Date(tpl.createdAt).toLocaleDateString(undefined, {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              })}
            </div>
          </div>
          <div className="template-card-actions">
            <Popconfirm
              title="Delete this template?"
              onConfirm={(e) => handleDelete(tpl.id, e)}
              okText="Yes"
              cancelText="No"
              okButtonProps={{ danger: true }}
            >
              <Button
                type="text"
                danger
                size="small"
                icon={<DeleteOutlined />}
                onClick={(e) => e.stopPropagation()}
              />
            </Popconfirm>
            <Button
              type="primary"
              size="small"
              onClick={() => onLoadTemplate(tpl.canvasJSON)}
              style={{ fontSize: '11px' }}
            >
              Load
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}
